const EquipmentRoute = [
  {
    path: '/SimList/:type',
    name: 'SimType',
    component: () => import(/* webpackChunkName: "user" */'../../views/Index/modules/SimList.vue'),
    meta: { title: 'SIM卡', showBackBtn: true }
  }
]

export default EquipmentRoute
